import React, { useState } from 'react'
import AiwellLogo from '../Assets/images/Aiwell Logo 1.png';
import Lottie from "lottie-react";
import walkthrough1 from '../Assets/animations/Walkthrough 1.json'
import walkthrough2 from '../Assets/animations/Walkthrough 2.json'
import walkthrough3 from '../Assets/animations/walkthrough 3.json'
import walkthrough4 from '../Assets/animations/walkthrough 4 (1).json'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import outerCircle from '../Assets/images/vector.png'
import { useSwipeable } from "react-swipeable";

import { useNavigate, useLocation } from 'react-router-dom';
import DoneIcon from '@mui/icons-material/Done';
import { Button } from '@mui/material';
import { ChairAlt } from '@mui/icons-material';
import awlogo from "../Assets/images/Group 16808.png";

function OnBoardingScreen() {

    const WalkThroughSection = [
        {
            name: "W1",
            animation: walkthrough1,
            text: "360&deg; Health Improvement<br/>using Integrative holistic wellness",
            background: false,
        },
        {
            name: "W2",
            animation: walkthrough2,
            text: "Regular monitoring of health status <br/>using digital biomarkers",
            background: false,
        },
        {
            name: "W3",
            animation: walkthrough3,
            text: "Personalized diet & recipes<br/>recommendations",
            background: false,
        },
        {
            name: "W4",
            animation: walkthrough4,
            text: "Holistic health enhancement using<br/>Yoga, Pranayama & Meditation",
            background: true,
        },
    ]

    const [index, setIndex] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();

    const ChangeAnimation = () => {
        setIndex(prevIndex => {
            if (prevIndex >= 3) {
                navigate('/Welcome');
                return 0;
            } else {
                return prevIndex + 1;
            }
        });
    };

    const circumference = 2 * Math.PI * 50;

    const offset = circumference - (index / 4) * circumference;

    const goToNextSlide = () => {
        if (index >= WalkThroughSection.length - 1) {
            navigate("/Packages", { state: { from: location?.state?.from } });
        } else {
            setIndex(index + 1);
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => goToNextSlide(),
        onSwipedRight: () => setIndex((prev) => Math.max(prev - 1, 0)),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    return <div className="Onboarding-Screen flex flex-col h-full" {...handlers}>

        <div className="flex flex-col items-center justify-between flex-grow">

            <div className="mb-2 lock-img flex justify-between w-full items-center">
                <img src={awlogo} alt="AW Logo" />
                <div
                    className="skip-btn flex justify-end"
                    style={{ justifySelf: "flex-end" }}
                    onClick={() => {
                        navigate("/Packages");
                    }}
                >
                    <p> Skip</p>
                </div>
            </div>

            <div>
                <div className={WalkThroughSection[index]?.background ?
                    'Onboarding-animation Onboarding-bg' : "Onboarding-animation"}>
                    <Lottie animationData={WalkThroughSection[index].animation} loop={false}></Lottie>
                </div>

                <div className='Onboarding-text-area'>
                    <p dangerouslySetInnerHTML={{ __html: WalkThroughSection[index].text }} />
                </div>
            </div>




            <div className="flex flex justify-between items-center" style=
                {{
                    width: "100%",

                }}>

                <div className="flex gap-2">
                    {WalkThroughSection.map((_, i) => (
                        <div
                            key={i}
                            onClick={() => setIndex(i)}
                            className={`h-3 w-3 rounded-full cursor-pointer transition-all ${i === index ? "bg-[#DA6E0B] w-8" : "bg-gray-300"
                                }`}
                        />
                    ))}
                </div>


                {index === WalkThroughSection.length - 1 ? (
                    <Button
                        style={{

                            textTransform: 'none',
                            borderRadius: '0',
                            backgroundColor: '#DA6E0B',
                            color: 'white',
                            display: "block",
                            fontSize: "12px",
                            border: 'none',
                            boxSizing: 'border-box',
                            borderRadius: '5px',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: '10px'
                        }}
                        onClick={goToNextSlide}
                    >
                        Let’s Do This!
                    </Button>
                ) : (
                    <button
                        className="bg-[#DA6E0B] text-white p-2 rounded-full flex items-center justify-center justify-center"
                        onClick={goToNextSlide}
                    >
                        <ArrowForwardIcon fontSize="small" />
                    </button>
                )}
            </div>

        </div>
    </div>
}

export default OnBoardingScreen